/**
 * 分类
 */
import CommonApi from 'api/common.js';
var url = '/dayaotex-server-goods/recommend/';
var AccountApi = {
  // 整个推荐板块中所有的商品大类
  selectDictionary: function selectDictionary(data) {
    return CommonApi.post('/dayaotex-server-goods/dictionary/selectDictionary', data);
  },
  // 查询单个推荐版中含有的大类
  selectExistRecommendTemplate: function selectExistRecommendTemplate(data) {
    return CommonApi.post(url + 'selectExistRecommendTemplate', data);
  },
  // app前台推荐列表
  selectAppRecommendList: function selectAppRecommendList(data) {
    return CommonApi.post(url + 'selectAppRecommendList', data);
  },
  // 单个推荐板块中的商品列表
  selectAppRelationRecommendGoodsList: function selectAppRelationRecommendGoodsList(data) {
    return CommonApi.post(url + 'selectAppRelationRecommendGoodsList', data);
  },
  // 查询推荐详情-包括banner
  selectRecommendInfo: function selectRecommendInfo(data) {
    return CommonApi.post(url + 'selectRecommendInfo', data);
  }
};
export default AccountApi;